import { VITE_OSS_PROVIDER } from '../common/const';

export const sleep = (durationInMs: number): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(resolve, durationInMs);
  });
};

export const isBuildIn = () => {
  //不要去掉问号，插件会报错
  try {
    // @ts-ignore env
    return __BUILD_IN__;
  } catch {
    // @ts-ignore env
    return import.meta?.env?.VITE_PRODUCT === 'buildin';
  }
};

export const isMinioProvider = () => {
  console.log(`VITE_OSS_PROVIDER: ${VITE_OSS_PROVIDER}`);
  return VITE_OSS_PROVIDER === 'minio';
};
